'use strict';

import resizeStore from '../resize/resize.store';
import dispatcher from '../dispatcher';

class AnchorView extends HTMLButtonElement {
  constructor() {
    super();

    this.onResize = (e) => this._onResize(e);
  }
  connectedCallback() {

    const dataAnchor = this.dataset.anchor;
    if (!dataAnchor) return;


    const anchorElement = document.querySelector(dataAnchor);

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this._onClick(anchorElement);
    })


    this._onResize(resizeStore.getData());
    resizeStore.eventEmitter.addListener(this.onResize);
  }
  disconnectedCallback() {
    resizeStore.eventEmitter.removeListener(this.onResize);
  }

  _onClick(dataAnchor) {

    dispatcher.dispatch({
      type: 'scroll-to',
      elem: dataAnchor
    })
  }
  _onResize(e) {
    const scrolled = window.scrollY;
    const vh = e.height;

    let globalTop = 0;
    for (let itemsKey in this._items) {
      const item = this._items[itemsKey];
      const bounds = item.el.getBoundingClientRect();

      item.top = bounds.top;
      item.bottom = scrolled + bounds.bottom ;

      globalTop = item.bottom;
    }

  }

}

customElements.define('anchor-view', AnchorView, { extends: 'button' });
